import { css } from '@emotion/css';

import {
  Colors,
  MEDIUM_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const navbarClassName = css({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  zIndex: 999,
});

export const innerClassName = css({
  alignItems: 'center',
  background: Colors.White,
  borderBottom: '1px solid #DDD',
  display: 'flex',
  padding: `${Spacing.MD}px ${Spacing.LG}px`,
  height: 68,
});

export const rightClassName = css({
  marginLeft: 'auto',
});

export const mobileMenuClassName = css({
  display: 'block',
  cursor: 'pointer',
  [MEDIUM_DEVICE_MQ]: {
    display: 'none',
  },
});

export const iconClassName = css({
  color: Colors.Primary,
  height: 20,
  width: 20,
});
